import Keycloak from 'keycloak-js'
import Axios from './axios'
import config from './config'
import { isPublicRoute } from './services/auth'

const keycloak = new Keycloak(config.keycloakConfig);

export const updateToken = async () => {
  try {
    await keycloak.updateToken(100);
    const token = getAccessToken();
    if (!token) throw new Error("Invalid");
    Axios.setAuthorization(getAccessToken()!);
    return token;
  } catch (error) {
    console.log(`not refreshed :: ` + new Date());
    await forceLogin();
  }
};

keycloak.onTokenExpired = updateToken;

export const initialize = () => {
  // Survey is rendered within iframes in many cases. Prevents redirect to keycloak in those cases.
  const isSurveyRoute = window.location.pathname.startsWith('/customer/survey/form/');
  // Public pages (e.g. the emailed DLT form) must resolve without a session too.
  const skipLoginRedirect = isSurveyRoute || isPublicRoute();

  // Keycloak's session-status iframe is framed from auth.qa.casaretail.ai, whose `frame-ancestors`
  // CSP lists only the deployed dashboard origins — never localhost. Left on, the browser blocks
  // the frame and init resolves unauthenticated, so local dev lands on the error screen. Deployed
  // origins are in the allow-list and keep the session check.
  const isLocalOrigin = ['localhost', '127.0.0.1'].includes(window.location.hostname);

  return keycloak.init({
    onLoad: skipLoginRedirect ? 'check-sso' : 'login-required',
    checkLoginIframe: !isLocalOrigin,
  })
}

export const redirectToLogin = () => {
  keycloak.clearToken()
  keycloak.login()
}

export const logout = () => {
  return keycloak.logout()
}

export const forceLogin = () =>
  Promise.allSettled([logout, redirectToLogin].map((fn) => fn()))

export const getAccessToken = () => {
  return keycloak.token
}

// Available even when the bootstrap `/users` call itself failed (TENANT_INACTIVE /
// NO_TENANT_ACCESS) — the token is already decoded client-side by keycloak-js, no extra request.
export const getEmail = () => {
  return keycloak.tokenParsed?.email as string | undefined
}

export default keycloak